import {
  UilCreateDashboard,
  UilSetting,
  UilUsersAlt,
  UilMonitor,
  UilMonitorHeartRate,
  UilDesktopCloudAlt,
  UilFileMedicalAlt,
  UilProcess,
} from '@iconscout/react-unicons';

import { Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';

const menus = [
  {
    to: '',
    key: '',
    name: 'dashboard',
    icon: 'UilCreateDashboard',
    subMenu: [],
  },
  {
    to: '/raw-data',
    key: 'raw-data',
    name: 'Raw Data',
    icon: 'UilMonitor',
  },
  {
    to: '/processed-data',
    key: 'processed-data',
    name: 'Processed Data',
    icon: 'UilProcess',
  },
  {
    to: '/diagnostic',
    key: 'diagnostic',
    name: 'Diagnostic Data',
    icon: 'UilDesktopCloudAlt',
  },
  {
    to: '/monitor/list',
    key: 'monitor',
    name: 'Monitor',
    icon: 'UilMonitorHeartRate',
  },
  {
    key: 'masters',
    name: 'Masters',
    icon: 'UilUsersAlt',
    subMenu: [
      {
        to: '/masters/dataTable',
        key: 'dataTable',
        name: 'Users',
        icon: null,
      },
      {
        to: '/masters/machines',
        key: 'machines',
        name: 'Machines',
        icon: null,
      },
      {
        to: '/masters/shifts',
        key: 'shifts',
        name: 'Shifts',
        icon: null,
      },
    ],
  },
  {
    to: '/pages/settings',
    key: 'settings',
    name: 'settings',
    icon: 'UilSetting',
  },
  {
    key: 'reports',
    name: 'Reports',
    icon: 'UilFileMedicalAlt',
    subMenu: [
      {
        to: '/reports/daily-report',
        key: 'daily-report',
        name: 'Daily Report',
        icon: null,
      },
      {
        to: '/reports/report-one',
        key: 'report1',
        name: 'Report One',
        icon: null,
      },
    ],
  },
];

const getMateraialIcon = (icon) => {
  switch (icon) {
    case 'UilCreateDashboard':
      return <UilCreateDashboard />;
    case 'UilUsersAlt':
      return <UilUsersAlt />;
    case 'UilSetting':
      return <UilSetting />;
    case 'UilMonitor':
      return <UilMonitor />;
    case 'UilMonitorHeartRate':
      return <UilMonitorHeartRate />;
    case 'UilDesktopCloudAlt':
      return <UilDesktopCloudAlt />;
    case 'UilFileMedicalAlt':
      return <UilFileMedicalAlt />;
    case 'UilProcess':
      return <UilProcess />;
    default:
      break;
  }
};

const MenuItems = React.memo(({ toggleCollapsed }) => {
  const { t } = useTranslation();

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  // const dispatch = useDispatch();

  const path = '/admin';

  const pathName = window.location.pathname;
  const pathArray = pathName ? pathName.split(path) : [];
  const mainPath = pathArray.length > 1 ? pathArray[1] : '';
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = menus.map((item) =>
    getItem(
      !item.subMenu?.length > 0 ? (
        <NavLink onClick={toggleCollapsed} to={`${path + item.to}`}>
          {t(item.name)}
        </NavLink>
      ) : (
        t(item.name)
      ),
      item.key,
      !topMenu && item.subMenu?.length > 0 ? (
        getMateraialIcon(item.icon)
      ) : (
        <NavLink className="menuItem-iocn" to={`${path + item.to}`}>
          {getMateraialIcon(item.icon)}
        </NavLink>
      ),
      item.subMenu?.length > 0
        ? item.subMenu.map((sub) =>
            getItem(
              <NavLink onClick={toggleCollapsed} to={`${path + sub.to}`}>
                {t(sub.name)}
              </NavLink>,
              sub.key,
              sub.icon,
            ),
          )
        : undefined,
    ),
  );

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
});

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
